
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Dashboard_svg__Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 31.57 31.57","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"Dashboard_svg__st0",attrs:{"d":"M15.78 0C7.08 0 0 7.08 0 15.78s7.08 15.78 15.78 15.78c8.71 0 15.79-7.08 15.79-15.78S24.49 0 15.78 0zm0 30.07C7.9 30.07 1.5 23.66 1.5 15.79S7.91 1.5 15.78 1.5c7.88 0 14.29 6.41 14.29 14.28s-6.41 14.29-14.29 14.29z"}}),_c('path',{staticClass:"Dashboard_svg__st0",attrs:{"d":"M15.79 5.07l2.96 2.88h2.17l-5.13-4.99-5.14 4.99h2.17zM15.78 26.5l-2.96-2.88h-2.17l5.13 4.99 5.14-4.99h-2.17zM7.95 20.92v-2.17l-2.88-2.97 2.88-2.96v-2.17l-4.99 5.13zM23.62 10.65v2.17l2.88 2.96-2.88 2.97v2.17l4.99-5.14zM10.18 12.23H21.4v1H10.18zM10.18 15.29H21.4v1H10.18zM10.18 18.34H21.4v1H10.18z"}})])
          )
        }
      }
    